import { createFileRoute } from '@tanstack/react-router';
import { JourneysCampaignSetupHandoff } from '@/pages/workspaces/automations/[campaignId]/workflow/routing';

function JourneysAutomationsSetupTriggerRoute() {
  const { campaignId } = Route.useParams();
  return <JourneysCampaignSetupHandoff campaignId={campaignId} step="trigger" />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/setup/trigger',
)({
  component: JourneysAutomationsSetupTriggerRoute,
});
